import { render } from "./custome.vue?vue&type=template&id=2debc0f6"
import script from "./custome.vue?vue&type=script&lang=js"
export * from "./custome.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__